import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

export interface ModalButton {
  text: string;
  color?: 'primary' | 'accent' | 'warn' | '';
  result?: unknown; // Value returned when this button is clicked
}

export interface ModalNotificationData {
  title: string;
  subtitle?: string;
  message?: string;
  buttons?: ModalButton[]; // Custom buttons - if not provided, defaults to "OK"
}

@Component({
  selector: 'app-modal-notification',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  templateUrl: './modal-notification.component.html',
  styleUrl: './modal-notification.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModalNotificationComponent {
  // Default buttons if none provided
  defaultButtons: ModalButton[] = [{ text: 'OK', color: 'primary', result: true }];

  constructor(
    public dialogRef: MatDialogRef<ModalNotificationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ModalNotificationData
  ) {
    // Log received data
    console.log('📩 Modal received data:', this.data);

    // Set default buttons if not provided
    if (!this.data.buttons || this.data.buttons.length === 0) {
      this.data.buttons = this.defaultButtons;
    }
  }

  onButtonClick(button: ModalButton): void {
    this.dialogRef.close(button.result !== undefined ? button.result : button.text);
  }
}
